import { render } from "./ShopIndex.vue?vue&type=template&id=d4b9ac16&ts=true"
import script from "./ShopIndex.vue?vue&type=script&lang=ts"
export * from "./ShopIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__